// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/theme-variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import consolidated theme variables */

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--color-background);
  color: var(--color-background-text);
  transition: background-color 0.3s, color 0.3s;
}

/* Global form elements use consolidated theme */
input, button, select, textarea {
  font-family: inherit;
}

.App {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  position: relative;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dark-mode-toggle {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

h1 {
  color: var(--link-color);
  text-align: center;
  margin-bottom: 20px;
}

h3 {
  color: var(--link-color);
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

th, td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: var(--button-bg-color);
  color: white;
}

tr:hover {
  background-color: #f1f1f1;
}

body.dark-mode tr:hover {
  background-color: #3a3a3a; /* Darker color for hover in dark mode */
}

a {
  text-decoration: none;
  color: var(--link-color);
  font-weight: bold;
}

p {
  margin: 5px 0;
}

textarea {
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-family: 'Courier New', Courier, monospace;
}

button {
  margin-top: 10px;
  padding: 10px 20px;
  background-color: var(--button-bg-color);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:hover {
  background-color: var(--button-hover-bg-color);
}

.login-container {
  display: flex;
  flex-direction: column;
  align-items: stretch; /* Stretch elements to fill the container */
  gap: 15px;
  max-width: 300px;
  margin: 0 auto;
  height: 100vh;
  justify-content: center;
}

.login-container h2 {
  text-align: center;
}

.login-container div {
  width: 100%;
  display: block; /* Ensure each div takes a full line */
  text-align: center;
}

.login-container input,
.login-container button {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: block; /* Force each button and input to be on a new line */
}

.bubble {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 15px;
  background-color: #e0f7fa;
  margin-bottom: 20px;
}

body.dark-mode .bubble {
  background-color: #3a3a3a;
}

/* New CSS class for highlighting new submissions */
.new-submission {
  animation: highlight 2s ease-in-out;
}

@keyframes highlight {
  0% {
    background-color: #ffff99;
  }
  100% {
    background-color: transparent;
  }
}

/* Light Theme Styles */
.cm-light-theme {
  color: #000;
  background-color: #f5f5f5;
}

.cm-light-theme .cm-content {
  caret-color: #000;
}

.cm-light-theme.cm-focused .cm-cursor {
  border-left-color: #000;
}

.cm-light-theme.cm-focused .cm-selectionBackground,
.cm-light-theme ::selection {
  background-color: #d7d4f0;
}

.cm-light-theme .cm-gutters {
  background-color: #f5f5f5;
  color: #999;
  border: none;
}

/* Dark Theme Styles */
.cm-dark-theme {
  color: #2e2c2c;
  background-color: #2e2e2e;
}

.cm-dark-theme .cm-content {
  caret-color: #e0e0e0;
}

.cm-dark-theme.cm-focused .cm-cursor {
  border-left-color: #e0e0e0;
}

.cm-dark-theme.cm-focused .cm-selectionBackground,
.cm-dark-theme ::selection {
  background-color: #4a4a4a;
}

.cm-dark-theme .cm-gutters {
  background-color: #6462620a;
  color: #b0b0b0;
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAGxC;EACE,4DAA4D;EAC5D,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,yCAAyC;EACzC,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA,gDAAgD;AAChD;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,wCAAwC;AACrE;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB,EAAE,2CAA2C;EACjE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc,EAAE,sCAAsC;EACtD,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,cAAc,EAAE,oDAAoD;AACtE;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,YAAY;AACd","sourcesContent":["/* Import consolidated theme variables */\n@import './styles/theme-variables.css';\n\nbody {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  background-color: var(--color-background);\n  color: var(--color-background-text);\n  transition: background-color 0.3s, color 0.3s;\n}\n\n/* Global form elements use consolidated theme */\ninput, button, select, textarea {\n  font-family: inherit;\n}\n\n.App {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  position: relative;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.dark-mode-toggle {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n}\n\nh1 {\n  color: var(--link-color);\n  text-align: center;\n  margin-bottom: 20px;\n}\n\nh3 {\n  color: var(--link-color);\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 20px;\n}\n\nth, td {\n  padding: 10px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\nth {\n  background-color: var(--button-bg-color);\n  color: white;\n}\n\ntr:hover {\n  background-color: #f1f1f1;\n}\n\nbody.dark-mode tr:hover {\n  background-color: #3a3a3a; /* Darker color for hover in dark mode */\n}\n\na {\n  text-decoration: none;\n  color: var(--link-color);\n  font-weight: bold;\n}\n\np {\n  margin: 5px 0;\n}\n\ntextarea {\n  width: 100%;\n  margin-top: 10px;\n  padding: 10px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  font-family: 'Courier New', Courier, monospace;\n}\n\nbutton {\n  margin-top: 10px;\n  padding: 10px 20px;\n  background-color: var(--button-bg-color);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\nbutton:hover {\n  background-color: var(--button-hover-bg-color);\n}\n\n.login-container {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch; /* Stretch elements to fill the container */\n  gap: 15px;\n  max-width: 300px;\n  margin: 0 auto;\n  height: 100vh;\n  justify-content: center;\n}\n\n.login-container h2 {\n  text-align: center;\n}\n\n.login-container div {\n  width: 100%;\n  display: block; /* Ensure each div takes a full line */\n  text-align: center;\n}\n\n.login-container input,\n.login-container button {\n  width: 100%;\n  padding: 10px;\n  box-sizing: border-box;\n  display: block; /* Force each button and input to be on a new line */\n}\n\n.bubble {\n  border: 1px solid #ccc;\n  padding: 10px;\n  border-radius: 15px;\n  background-color: #e0f7fa;\n  margin-bottom: 20px;\n}\n\nbody.dark-mode .bubble {\n  background-color: #3a3a3a;\n}\n\n/* New CSS class for highlighting new submissions */\n.new-submission {\n  animation: highlight 2s ease-in-out;\n}\n\n@keyframes highlight {\n  0% {\n    background-color: #ffff99;\n  }\n  100% {\n    background-color: transparent;\n  }\n}\n\n/* Light Theme Styles */\n.cm-light-theme {\n  color: #000;\n  background-color: #f5f5f5;\n}\n\n.cm-light-theme .cm-content {\n  caret-color: #000;\n}\n\n.cm-light-theme.cm-focused .cm-cursor {\n  border-left-color: #000;\n}\n\n.cm-light-theme.cm-focused .cm-selectionBackground,\n.cm-light-theme ::selection {\n  background-color: #d7d4f0;\n}\n\n.cm-light-theme .cm-gutters {\n  background-color: #f5f5f5;\n  color: #999;\n  border: none;\n}\n\n/* Dark Theme Styles */\n.cm-dark-theme {\n  color: #2e2c2c;\n  background-color: #2e2e2e;\n}\n\n.cm-dark-theme .cm-content {\n  caret-color: #e0e0e0;\n}\n\n.cm-dark-theme.cm-focused .cm-cursor {\n  border-left-color: #e0e0e0;\n}\n\n.cm-dark-theme.cm-focused .cm-selectionBackground,\n.cm-dark-theme ::selection {\n  background-color: #4a4a4a;\n}\n\n.cm-dark-theme .cm-gutters {\n  background-color: #6462620a;\n  color: #b0b0b0;\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
